import { render, staticRenderFns } from "./collect-minimization.vue?vue&type=template&id=02d99ebd&scoped=true"
import script from "./collect-minimization.vue?vue&type=script&lang=js"
export * from "./collect-minimization.vue?vue&type=script&lang=js"
import style0 from "./collect-minimization.vue?vue&type=style&index=0&id=02d99ebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d99ebd",
  null
  
)

export default component.exports